import _ from "lodash";
import React, { Component } from "react";
import Button from "react-bootstrap-button-loader";
import { connect } from "react-redux";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { Modal, Row, Col } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import { Field, reduxForm, reset } from "redux-form";
import LocaleStrings from "Languages";

import { addLiveQA } from "LiveQAAction";
import { COMMON_FAIL_MESSAGE, maxLengthObjectFc } from "Constants";
var MAXLENOBJ = {};
class AddLiveQA extends Component {
  constructor(props) {
    super(props);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.state = { loading: false, showModal: false };
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  openModal = () => {
    this.props.reset();
    this.setState({ loading: false, showModal: true });
  };

  closeModal = () => {
    this.props.reset();
    this.setState({ showModal: false });
  };

  onSubmitForm(values) {
    let { selectedSession, selectPublishedType } = this.props;
    this.setState({ loading: true });
    this.props.addLiveQA(
      this.props.session,
      values,
      selectedSession,
      (response) => {
        if (response.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.polls_qa_message_qa_added_seccess
          );
          this.closeModal();
        }
      }
    );
  }

  render() {
    var { handleSubmit, pristine, reset, submitting, invalid, initialValues } =
      this.props;

    return (
      <div>
        <span className="pull-right">
          <button
            type="button"
            className="btn btn-custom-blue"
            onClick={this.openModal}
          >
            {/* <i className="fa fa-plus i-custom-m"></i>{LocaleStrings.polls_qa_text_add_qa} */}
            <img
              style={{ paddingRight: 8, paddingBottom: 3 }}
              src="../../style/images/header-icons/plus.png"
            ></img>
            {LocaleStrings.polls_qa_text_add_qa}
          </button>
        </span>
        <div>
          <Modal
            className="modal-container"
            show={this.state.showModal === true ? true : false}
            onHide={this.closeModal}
            animation={true}
          >
            <form
              onSubmit={handleSubmit(this.onSubmitForm)}
              encType="multipart/form-data"
            >
              <Modal.Header>
                <div className="import-modal-title">
                  {LocaleStrings.polls_qa_text_create_live_qa}
                </div>
                <button
                  type="button"
                  className="i-custom-cross-popup pull-right"
                  onClick={() => this.closeModal()}
                >
                  <img
                    className="i-custom-small"
                    src="../../style/images/custom-icons/cross-black.png"
                  />
                </button>
              </Modal.Header>
              <Modal.Body>
                {/* <div className="import-header">
                                <div className="import-modal-title">{LocaleStrings.polls_qa_text_create_live_qa}</div>
                                <button type="button" className="close btn-sm btn-close " onClick={() => this.closeModal()} style={{marginTop:-25}}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div> */}
                <div>
                  <AddLiveQAForm
                    scheduleSessions={this.props.scheduleSessions}
                    initialValues={initialValues}
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn btn-custom-white"
                  onClick={this.closeModal}
                >
                  {LocaleStrings.button_close}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  loading={this.state.loading}
                  disabled={pristine || invalid || submitting}
                  type="submit"
                >
                  {LocaleStrings.button_save}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  let initVals = { sessionid: state.selectedSession.resource };
  return {
    session: state.session,
    selectedSession: state.selectedSession.resource,
    scheduleSessions: state.scheduleSessions.resource,
    selectPublishedType: state.selectPublishedType,
    initialValues: initVals,
  };
}

function validate(values) {
  var errors = {};
  var question = values["question"];
  var sessionid = values["sessionid"];
  var maxLengthFields = ["question"];
  if (!question || question.trim() === "") {
    errors["question"] = LocaleStrings.polls_qa_validation_required;
  }
  if (!sessionid) {
    errors["sessionid"] = LocaleStrings.polls_qa_validation_required;
  }

  /*** Max Length Validation ***/
  maxLengthFields.forEach((field) => {
    if (values[field] && MAXLENOBJ) {
      if (values[field].length > MAXLENOBJ[field]) {
        errors[field] = LocaleStrings.max_characters_left + MAXLENOBJ[field];
      }
    }
  });

  return errors;
}

export default connect(mapStateToProps, { addLiveQA, showError, showSuccess })(
  reduxForm({
    validate,
    form: "liveqaForm",
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
  })(AddLiveQA)
);

class AddLiveQAForm extends BaseComponent {
  render() {
    let sessionArray = [];
    if (
      this.props.scheduleSessions &&
      this.props.scheduleSessions.scheduleSession
    ) {
      this.props.scheduleSessions.scheduleSession.map((object, index) => {
        let obj = {
          name:
            object.scheduledate +
            " | " +
            object.trackname +
            " | " +
            object.title,
          value: object.sessionid,
        };
        sessionArray.push(obj);
      });
    }
    return (
      <div className="basicform">
        <Field
          name="sessionid"
          label={LocaleStrings.polls_qa_form_label_session}
          placeholder={LocaleStrings.polls_qa_form_label_session_placeholder}
          component={this.renderSelect}
          opts={sessionArray}
          labelposition={LABEL_POSITION_TOP}
        />
        <Field
          name="question"
          label={LocaleStrings.polls_qa_form_label_what_you_ask}
          placeholder={
            LocaleStrings.polls_qa_form_label_what_you_ask_placeholder
          }
          type="text"
          component={this.renderFieldText}
          mandatory="true"
          labelposition={LABEL_POSITION_TOP}
          maxlength={MAXLENOBJ.question ? MAXLENOBJ.question : ""}
        />
      </div>
    );
  }
}
